import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {Select, SelectProps} from '@innowise-group/ui-kit';
import {WorkspaceBookType} from '@shared/core';
import {getStatusesInWorkspaceSelect} from '../../utilities';

interface WorkspaceStatusSelectProps extends SelectProps {
  isVirtual: boolean;
  value: WorkspaceBookType;
  excludeFree?: boolean;
}

const WorkspaceStatusSelect: React.FC<WorkspaceStatusSelectProps> = ({isVirtual, excludeFree, value, ...props}) => {
  const {t} = useTranslation();

  const items = useMemo(() => {
    return getStatusesInWorkspaceSelect(t, excludeFree, isVirtual, value);
  }, [t, excludeFree, value, isVirtual]);

  const transformValue = (value) => {
    return items.find((item) => item.value === value)?.title;
  };

  return <Select {...props} value={value} options={items} withSearch={false} valueTransformer={transformValue} />;
};

export default WorkspaceStatusSelect;
